import React from "react";
import { Box } from "@mui/material";
import DisplayProjects from "./ShowProjects.js";

export default function FullStackProjectsTab() {
  return (
    <Box>
      <DisplayProjects category="fullstack" />
    </Box>
  );
}